var module = angular.module('main.resellerorder');

module.component('createResellerOrderAddLineItems',{
    templateUrl: 'main/resellerorder/resellerordermodify/components/addlineitems.cmp.tpl.html',
    bindings: {
        resellerOrder: '=',
        onLineItemChanged: '&',
        onVariantChanged: '&'
    },
    controllerAs: 'vm',
    controller: ['$scope', componentController]
});

// @ngInject
function componentController($scope) {
    var vm = this;

    //Properties
    vm.excludedArticles = [];
    vm.tabSelection = {
        overview: false,
        quantity: true,
        amount: false
    };

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.receiveArticles = receiveArticles;
    vm.saveLineItem = saveLineItem;
    vm.saveVariant = saveVariant;
    vm.canModifyLineItems = canModifyLineItems;
    vm.changeToTab = changeToTab;

    function onInit() {
        $scope.$watch(function () { return vm.resellerOrder.lineItems.length; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                updateArticlesToExclude();
            }
        });
    }
    function onChanges() {
    }

    function changeToTab(tab) {
        switch (tab) {
            default:
            case 'overview': vm.tabSelection = {
                    overview: true,
                    quantity: false,
                    amount: false
                };
                break;
            case 'quantity': vm.tabSelection = {
                    overview: false,
                    quantity: true,
                    amount: false
                };
                break;
            case 'amount': vm.tabSelection = {
                    overview: false,
                    quantity: false,
                    amount: true
                };
                break;
        }
    }

    function updateArticlesToExclude() {
        vm.excludedArticles = _.chain(vm.resellerOrder.lineItems)
            .groupBy('articleId')
            .map((value, key) => ({ articleId: parseInt(key) }))
            .value();
    }

    function canModifyLineItems() {
        var canModifyLineItems = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'upsertLineItems'; }) !== undefined;

        return canModifyLineItems;
    }

    function saveLineItem(lineItem) {
        vm.onLineItemChanged({ lineItem: lineItem });
    }
    function saveVariant(variant) {
        vm.onVariantChanged({ variant: variant });
    }

    function receiveArticles(articles) {
        if (!vm.resellerOrder.lineItems) { vm.resellerOrder.lineItems = []; }

        _.forEach(articles, function(art) {
            _.forEach(art.variants, function(variant) {
                var newListItem = {
                    amount: variant.price,
                    articleId: variant.articleId,
                    articleName: variant.articleName,
                    displayArticleNumber: variant.displayArticleNumber,
                    articleVariantId: variant.id,
                    fulfilledQuantity: 0,
                    id: 0,
                    links: [{ rel: 'modify' }],
                    orderId: vm.resellerOrder.id,
                    plannedDeliveryDateUtc: new Date(variant.plannedDeliveryDate),
                    quantity: 0,
                    status: 'open',
                    variantDetail1Name: variant.variantDetail1Name,
                    variantDetail2Name: variant.variantDetail2Name,
                    variantDetail2SortOrder: variant.variantDetail2SortOrder,
                    vatAmount: variant.vatAmount,
                    vatRate: variant.vatRate
                };

                vm.resellerOrder.lineItems.push(newListItem);
            });
        });
    }
}
